var portfolioPositionsWeight = {
	caption: "Portfoliopositionen Gewicht",
	label: {
		name: "Name",
		isin: "ISIN",
		marketValue: "Marktwert",
		weight: "Gewicht %",
		weightBar: "Gewicht % von max"
	},
	noPositions: "Keine Ergebnisse gefunden"
};
var de = {
	portfolioPositionsWeight: portfolioPositionsWeight
};

export { de as default, portfolioPositionsWeight };
